import { createFileRoute, redirect } from '@tanstack/react-router';
import AllianceApplicationDetailTemplate from '@/features/agent/alliance/templates/AllianceApplicationDetailTemplate';

export const Route = createFileRoute('/agent/alliance/applications/$applicationId/')({
  component: AllianceApplicationDetail,
  staticData: { title: 'アライアンス' },
  beforeLoad: async () => {
    const response = await fetch('/agent/api/iam.json');
    if (!response.ok) {
      throw redirect({ to: '/agent' });
    }
    const data = await response.json();
    if (!data.is_alliance_enabled) {
      throw redirect({ to: '/agent' });
    }
  },
});

function AllianceApplicationDetail() {
  const { applicationId } = Route.useParams();

  return <AllianceApplicationDetailTemplate applicationId={applicationId} />;
}
